module.exports = __webpack_public_path__ + "img/sovalis-logo-rouge.8147f4dd.png";